<template>
	<drawer
			:title="getNameDrawer"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<field
				margin="0 0 10px 0"
				:class-error="getError('name_id')"
				@updateSelect="onSelect($event, 'name_id')"
				:autocompleteValue="name_id"
				:items="inventoryTypes"
				label="Parent"
				item-text="name"
				item-value="id"
				is-select
				:isClearable="false"
				is-attach
				is-required
		></field>
		<field
				margin="0 0 10px 0"
				:class-error="getError('type_id')"
				@updateSelect="onSelect($event, 'type_id')"
				:autocompleteValue="type_id"
				:items="inventoryTypeList"
				label="Inventory"
				item-text="name"
				item-value="id"
				is-select
				:isClearable="false"
				is-attach
				is-required
				:is-disabled="!name_id"
		></field>

		<field
				:class-error="getError('series')"
				margin="0 0 10px 0"
				width="300px"
				label="Series number"
				placeholder="Enter series number"
				:setInputValue="series"
				@updateInput="onInput($event, 'series')"
				is-required
		></field>

	</drawer>
</template>

<script>

import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	name: "EditInventory",
	mixins: [ validationMixin ],
	components: { Drawer },
	props: {
		item: Object,
		dialogFlag: String,
		inventoryTypes: Array,
	},
	computed: {
		getNameDrawer() {
			if (this.inventoryTypes.length > 0) return 'Edit this contact';
			return 'Add new contact';
		},
	},
	validations: {
		name_id: { required },
		type_id: { required },
		series: { required },
	},

	data() {
		return {
			inventoryTypeList: null,

			id: null,
			name_id: null,
			type_id: null,
			uniqKey: null,
			type: null,
			series: null,
			name: null,
		};
	},
	methods: {
		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { name_id, type, series, type_id, name, uniqKey, id } = this.$data;
				this.$emit('updateSave', { name_id, type, series, type_id, name, uniqKey, id });
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "Saving error" });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},

		onSelect({ value }, key) {
			const { type, id, name } = value;

			// this[key] = value;

			if (key === 'name_id') {
				this.inventoryTypeList = type.length > 0 ? type : null;
				this.name_id = id;
				// this.type = name;
				this.name = name;
			}
			if (key === 'type_id') {
				this.type_id = id;
				// this.name = name;
				this.type = name;
			}

		},

		onInput({ value }, key) {
			this[key] = value;
		},
	},

	mounted() {
		if (this.item) {
			const {
				id,
				type_id,
				name,
				name_id,
				series,
				type,
				uniqKey,
			} = this.item;

			const idName = name_id;

			const ext = this.inventoryTypes.filter(item => item.id === idName);
			this.inventoryTypeList = ext[0].type ? ext[0].type : null;

			this.id = id;
			this.uniqKey = uniqKey;
			this.series = series;
			this.name = name;
			this.type = type;
			this.type_id = type_id;
			this.name_id = name_id;
		}
	}
};

</script>

<style scoped lang="scss">
@import "EditInventory";
</style>
